export default [
    "20 20",
    '<path d="M2 5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V5Z" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M2 7H18" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round"/>' +
    '<path d="M7 7V17" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round"/>' +
    '<path d="M2 11H18" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round"/>' +
    '<path d="M2 14H18" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round"/>'
]
